import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const EditSolid12Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1754 0q61 0 114 21t94 60 63 91 23 114q0 47-10 84t-28 69-44 62-58 61l-424-423q31-31 59-57t60-44 67-28 84-10zm-420 290l422 422L753 1713 0 2046l348-759 986-997z" />
    </svg>
  ),
  displayName: 'EditSolid12Icon',
});

export default EditSolid12Icon;
